import { useQuery } from '@tanstack/react-query'

import { TrailFinderQuestion } from '../models'
import { ApiQueryService } from '../services'
import { TRAIL_FINDER_QUESTIONS_QUERY_KEY } from './useTrailFinderQuestions'

export function useIsTrailFinderConfigured() {
  const { data, isLoading } = useQuery<TrailFinderQuestion[]>({
    queryFn: async () =>
      new ApiQueryService().get<TrailFinderQuestion[]>({
        endpoint: 'trail-finder-question/list',
      }),
    queryKey: TRAIL_FINDER_QUESTIONS_QUERY_KEY,
  })

  return {
    isConfigured: !!data?.length,
    isLoading,
  }
}
